import { useState } from "react";

export const useToggle = (initialState = false) => {
    const [open, setOpen] = useState(initialState);

    const toggleOpen = () => {
        setOpen(!open);
    };
    return { open, toggleOpen };
};
